import { Flex, Text } from "@chakra-ui/react";

export const BackupCheckDetailLegend = () => {
  return (
    <Flex alignItems="center" gap="30px">
      <Text
        fontWeight={700}
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            fontSize: "12px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            fontSize: "14px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            fontSize: "16px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            fontSize: "18px",
          },
          "@media (max-width: 1900px)": {
            fontSize: "20px",
          },
        }}
      >
        Detalle
      </Text>
    </Flex>
  );
};
